import { HIDE_DATA_SYMBOL, UNBREAKABLE_SEPARATOR } from 'constants/string';

export const getProtectedDescriptionWithUserData = (additionalPhoneOwner?: string, isHideData = false) => {
  if (!additionalPhoneOwner) return '';

  return isHideData ? Array(3).fill(HIDE_DATA_SYMBOL.repeat(4)).join(UNBREAKABLE_SEPARATOR) : additionalPhoneOwner;
};
